export default class extends Controller {
  connect() {
    console.log('Favorite controller connected');

    if (this.element.dataset.userLoggedIn === 'false') {
    }
  }
}
